import React, { Component } from 'react';

// Editor de texto enriquecido basado en Froala (antes usaba CKEditor5, que
// crasheaba por falta del build → pantalla en blanco, bugs E-01/E-02 del QA).
// Se mantiene el nombre del componente y su API (props `formValues` y
// `HandleChange`) para no tocar los 6 lugares que ya lo importan.
import 'froala-editor/js/froala_editor.pkgd.min.js';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/languages/es';
import FroalaEditor from 'react-froala-wysiwyg';

class Ckeditor extends Component {
    render() {
        const config = {
            language: 'es',
            key: this.props.key_text,
            heightMin: 150,
            quickInsertEnabled: false,
            linkAlwaysBlank: true,
            paragraphFormatSelection: true,
            placeholderText: 'Escribe aquí…',
            toolbarButtons: {
                moreText: {
                    buttons: ['bold', 'italic', 'underline', 'strikeThrough', 'fontSize', 'textColor', 'backgroundColor'],
                    buttonsVisible: 6,
                },
                moreParagraph: {
                    buttons: ['alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOL', 'formatUL'],
                    buttonsVisible: 6,
                },
                moreRich: {
                    buttons: ['insertLink', 'insertTable'],
                    buttonsVisible: 2,
                },
                moreMisc: {
                    buttons: ['undo', 'redo', 'fullscreen'],
                    align: 'right',
                    buttonsVisible: 3,
                },
            },
        };

        return (
            <div className="App">
                <FroalaEditor
                    tag="textarea"
                    model={this.props.formValues}
                    config={config}
                    onModelChange={(data) => this.props.HandleChange(data)}
                />
            </div>
        );
    }
}

export default Ckeditor;
